import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfirmDeployInstanceDialogComponent } from './confirm-deploy-instance-dialog.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { SidenavHeaderModule } from 'src/app/components/sidenav-header/sidenav-header.module';
import { PipesModule } from 'src/app/pipes/pipes.module';
import { MatDividerModule } from '@angular/material/divider';



@NgModule({
  declarations: [
    ConfirmDeployInstanceDialogComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    PipesModule,

    SidenavHeaderModule,

    MatDividerModule,
  ],
  exports: [
    ConfirmDeployInstanceDialogComponent
  ],
})
export class ConfirmDeployInstanceDialogModule { }
